import { SUBSCRIPTION_PLAN_CATEGORY, type SubscriptionPlanCategory } from './const';

const CATEGORY_LABEL_MAP: Record<SubscriptionPlanCategory, string> = {
  [SUBSCRIPTION_PLAN_CATEGORY.basic]: 'Free',
  [SUBSCRIPTION_PLAN_CATEGORY.starter]: 'Starter',
  [SUBSCRIPTION_PLAN_CATEGORY.dataDriven]: 'Data-Driven',
  [SUBSCRIPTION_PLAN_CATEGORY.business]: 'Business',
  [SUBSCRIPTION_PLAN_CATEGORY.enterprise]: 'Enterprise',
  [SUBSCRIPTION_PLAN_CATEGORY.poc]: 'POC',
};

export const getPlanCategoryLabel = (category: SubscriptionPlanCategory): string => {
  return CATEGORY_LABEL_MAP[category] || '';
};
